import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import {
    PersonActionTypes,
    LoadPersonsSuccess,
    LoadPersons,
    LoadPersonTypeSuccess,
    LoadPersonType,
    LoadPersonsFail,
    LoadPersonTypeFail,
    GetAgencyPersonMapping,
    LoadPersonAgencySuccess,
    GetAgencyPersonStatusHistory,
    LoadPersonAgencyStatusHistorySuccess,
    GetAgencyAdminProfile,
    LoadAAProfileSuccess,
    LoadAAPersonFail,
    GetAgencyAdminAgencies,
    LoadAAAgencySuccess,
    GetDesignatedRepresentativeStatusHistory,
    LoadDesignatedRepresentativeStatusHistorySuccess,
    GetDesignatedRepresentative,
    DesignatedRepresentativeDetail,
    GetSFSuccess,
    LoadParticipantCaregiverPayRates,
    LoadParticipantCaregiverPayRatesFail,
    LoadParticipantCaregiverPayRatesSuccess,
    LoadParticipantDrRelation,
    LoadParticipantDrRelationFail,
    LoadParticipantDrRelationSuccess,
    LoadParticipantEmployerOfRecordRelation,
    SFDetail,
    LoadParticipantEmployerOfRecordRelationSuccess,
    LoadParticipantEmployerOfRecordRelationFail,
    LoadParticipantCaregiverRelation,
    LoadParticipantCaregiverRelationFail,
    LoadParticipantCaregiverRelationSuccess,
    LoadParticipant,
    LoadParticipantSuccess,
    LoadParticipantFail,
    LoadEmployerOfRecord,
    LoadEmployerOfRecordSuccess,
    LoadEmployerOfRecordFail,
    LoadCaregiver,
    LoadCaregiverFail,
    LoadCaregiverSuccess,
    LoadDRProfileSuccess,
    GetDRProfile,
    LoadDRPersonFail,
    GetDRParticipant,
    LoadDRParticipantSuccess,
    LoadCaregiverProfile,
    LoadCaregiverProfileSuccess,
    LoadCaregiverProfileFail,
    LoadEmployerOfRecordParticipant,
    LoadEmployerOfRecordParticipantSuccess,
    LoadEmployerOfRecordPersonFail,
    LoadEmployerOfRecordCaregiver,
    LoadEmployerOfRecordCaregiverSuccess,
    GetSFProfile,
    LoadSFProfileSuccess,
    LoadSFPersonFail,
    GetSFAgencies,
    LoadCaregiverParticipantRelationFail,
    LoadCaregiverParticipantRelation,
    LoadCaregiverParticipantRelationSuccess,
    LoadCaregiverEmployerOfRecordRelation,
    LoadCaregiverEmployerOfRecordRelationSuccess,
    LoadCaregiverEmployerOfRecordRelationFail,
    LoadSFAgencySuccess,
    GetSFCaseLoads,
    LoadSFCaseLoadsSuccess,
    LoadProgramCoordinator,
    LoadProgramCoordinatorSuccess,
    LoadProgramCoordinatorFail,
    LoadProgramCoordinatorProfileSuccess,
    LoadProgramCoordinatorProfileFail,
    LoadProgramCoordinatorProfile
} from './person.actions';
import { mergeMap, map, catchError } from 'rxjs/operators';
import {
    PeopleFunctionService,
    PersonResponseDtoGridResponseBase,
    IStringInt32KeyValuePair,
    PersonRequestDto,
    PersonAgenciesDto,
    StatusHistory,
    PersonType,
    ParticipantDesignatedRepresentative,
    AgencyAdminProfile,
    DesignatedRepresentativeProfile,
    Participants,
    Relationships,
    CaregiverDetails,
    CaregiverProfile,
    ProgramCoordinatorDto,
    ProgramCoordinatorProfile,
    ServiceFacilitatorProfile,
    CaregiverEmployerList,
    AgencyPersonMapping,
    ServiceFacilitatorCaseLoad,
    EmployerOfRecordResponse,
    CustEmpRelResponseDtoGridResponseBase,
    CustEmpRelFilterRequest,
    ParticipantEmployerOfRecordListGridResponseBase
} from 'src/app/core/services/peopleapi/peoplefunctionapi.services';

import { of } from 'rxjs';
import { CommonDropdownService } from 'src/app/shared/services/common-dropdown.service';
// eslint-disable-next-line max-len
import { PayRateService, PayRateModel } from 'src/app/core/services/u2api.services';

@Injectable()
export class PersonEffects {

    // eslint-disable-next-line max-len
    constructor(private readonly action$: Actions,
        private readonly u2CustEmpService: PeopleFunctionService,
        private readonly peopleService: PeopleFunctionService,
        private readonly u2PayRateService: PayRateService,
        private readonly commonDropdownService: CommonDropdownService) { }

    LoadPersons$ = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadPersons),
        mergeMap((action: LoadPersons) => this.peopleService.getAllPersonBySearchCriteria(action.payload as PersonRequestDto).pipe(
            map((persons: PersonResponseDtoGridResponseBase) => (new LoadPersonsSuccess(persons))
            )).pipe(
                catchError(err => of(new LoadPersonsFail(err))))
        )));

    LoadPersonType$ = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadPersonType),
        mergeMap((action: LoadPersonType) => this.peopleService.getAllPersonTypes().pipe(
            map((personType: Array<IStringInt32KeyValuePair>) => (new LoadPersonTypeSuccess(personType))
            )).pipe(
                catchError(err => of(new LoadPersonTypeFail(err))))
        )));

    LoadParticipantCaregiverPayRates$ = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadParticipantCaregiverPayRates),
        // eslint-disable-next-line max-len
        mergeMap((action: LoadParticipantCaregiverPayRates) => this.u2PayRateService.getPayRateByParticipant(action.empId as number, action.participantId as number).pipe(
            map((payRate: PayRateModel[]) => (new LoadParticipantCaregiverPayRatesSuccess(payRate)))).pipe(
                catchError(err => of(new LoadParticipantCaregiverPayRatesFail(err))))
        )));


    LoadParticipantDrRelation$ = this.action$.pipe(
        ofType(PersonActionTypes.LoadParticipantDrRelation),
        // eslint-disable-next-line max-len
        mergeMap((action: LoadParticipantDrRelation) => this.peopleService.getParticipantDesignatedRep(action.participantId as number).pipe(
            map((ptpDrRelation: ParticipantDesignatedRepresentative[]) => (new LoadParticipantDrRelationSuccess(ptpDrRelation)))).pipe(
                catchError(err => of(new LoadParticipantDrRelationFail(err))))
        ));


    ParticipantEmployerOfRecordRelation$ = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadParticipantEmployerOfRecordRelation),
        // eslint-disable-next-line max-len
        mergeMap((action: LoadParticipantEmployerOfRecordRelation) => this.peopleService.getParticipantEmployersOfRecord(action.participantId as number).pipe(
            map((ptpEmployerOfRecordRelation: ParticipantEmployerOfRecordListGridResponseBase) =>
            (new LoadParticipantEmployerOfRecordRelationSuccess(ptpEmployerOfRecordRelation))))
            .pipe(catchError(err => of(new LoadParticipantEmployerOfRecordRelationFail(err))))
        )));


    ParticipantCaregiverRelation$ = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadParticipantCaregiverRelation),
        // eslint-disable-next-line max-len
        mergeMap((action: LoadParticipantCaregiverRelation) => this.u2CustEmpService.getAllCustEmpRelations(action.payload as CustEmpRelFilterRequest).pipe(
            // eslint-disable-next-line max-len
            map((ptpCaregiverRelation: CustEmpRelResponseDtoGridResponseBase) => (new LoadParticipantCaregiverRelationSuccess(ptpCaregiverRelation)))).pipe(
                catchError(err => of(new LoadParticipantCaregiverRelationFail(err))))
        )));

    // Agency Admin by person

    personDetail = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadPersonsAgency),
        mergeMap((action: GetAgencyPersonMapping) => this.peopleService.getAgencyAdmin(action.payload).pipe(
            map((personAgenciesDto: PersonAgenciesDto) => (new LoadPersonAgencySuccess(personAgenciesDto))
            )).pipe(
                catchError(err => of(new LoadPersonTypeFail(err))))
        )));

    // Agency Admin status history

    personStatusHistoryDetail = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadPersonsAgencyStatusHistory),
        mergeMap((action: GetAgencyPersonStatusHistory) => this.peopleService.getAgencyAdminStatusHistory(action.payload).pipe(
            map((statusHistory: Array<StatusHistory>) => (new LoadPersonAgencyStatusHistorySuccess(statusHistory)))).pipe(
                catchError(err => of(new LoadPersonTypeFail(err))))
        )));


    AgencyAdminDetail = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadAgencyAdminProfile),
        mergeMap((action: GetAgencyAdminProfile) => this.peopleService.getAgencyAdminUserProfile(action.payload).pipe(
            map((AAProfile: AgencyAdminProfile) => (new LoadAAProfileSuccess(AAProfile)))).pipe(
                catchError(err => of(new LoadPersonTypeFail(err))))
        )));


    AgencyAdminAgencies = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadAgencyAdminAgencies),
        mergeMap((action: GetAgencyAdminAgencies) => this.peopleService.getAgencyAdminAgencies(action.peopleId).pipe(
            map((AgencyAdminAgencies: Array<AgencyPersonMapping>) => (new LoadAAAgencySuccess(AgencyAdminAgencies, action.peopleId)))).pipe(
                catchError(err => of(new LoadAAPersonFail(err))))
        )));

    // Designated Representative


    persondrDetail = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.DesignatedRepresentativeDetail),
        mergeMap((action: GetDesignatedRepresentative) => this.peopleService.getDesignatedRepresentative(action.payload).pipe(
            map((personTypeDto: PersonType) => (new DesignatedRepresentativeDetail(personTypeDto)))).pipe(
                catchError(err => of(new LoadPersonTypeFail(err))))
    )));


    personDRStatusHistoryDetail = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadPersonsDesignatedRepresentativeStatusHistory),
        // eslint-disable-next-line max-len
        mergeMap((action: GetDesignatedRepresentativeStatusHistory) => this.peopleService.getDesignatedRepresentativeStatusHistory(action.payload).pipe(
            map((drstatusHistory: Array<StatusHistory>) => (new LoadDesignatedRepresentativeStatusHistorySuccess(drstatusHistory)))).pipe(
                catchError(err => of(new LoadPersonTypeFail(err))))
        )));


    DRProfileDetail = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadPersonsDRProfile),
        mergeMap((action: GetDRProfile) => this.peopleService.getDesignatedRepresentativeProfile(action.payload).pipe(
            map((DRProfile: DesignatedRepresentativeProfile) => (new LoadDRProfileSuccess(DRProfile)))).pipe(
                catchError(err => of(new LoadDRPersonFail(err))))
        )));

    // SF

    SFDetail = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadSFAgencies),
        mergeMap((action: SFDetail) => this.peopleService.getServiceFacilitator(action.payload).pipe(
            map((personAgenciesDto: PersonAgenciesDto) => (new GetSFSuccess(personAgenciesDto)))).pipe(
                catchError(err => of(new LoadPersonTypeFail(err))))
        )));


    DRParticipantDetail = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadDRParticipant),
        mergeMap((action: GetDRParticipant) => this.peopleService.getDesignatedRepresentativeParticipant(action.payload).pipe(
            map((DRparticipantDto: Array<ParticipantDesignatedRepresentative>) =>
                (new LoadDRParticipantSuccess(DRparticipantDto, action.payload)))).pipe(
                    catchError(err => of(new LoadDRPersonFail(err))))
        )));



    LoadParticipant$ = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadParticipant),
        mergeMap((action: LoadParticipant) => this.peopleService.getParticpant(action.payload as string).pipe(
            map((participant: Participants) => (new LoadParticipantSuccess(participant)))).pipe(
                catchError(err => of(new LoadParticipantFail(err))))
        )));


    LoadEmployerOfRecord$ = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadEmployerOfRecord),
        mergeMap((action: LoadEmployerOfRecord) => this.peopleService.getEmployerOfRecordDetailsById(action.payload as string).pipe(
            map((ea: EmployerOfRecordResponse) => (new LoadEmployerOfRecordSuccess(ea)),
            )).pipe(
                catchError(err => of(new LoadEmployerOfRecordFail(err))))
        )));


    LoadCaregiver$ = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadCaregiver),
        mergeMap((action: LoadCaregiver) => this.peopleService.getCaregiver(action.payload as string).pipe(
            map((caregiver: CaregiverDetails) => (new LoadCaregiverSuccess(caregiver)))).pipe(
                catchError(err => of(new LoadCaregiverFail(err))))
        )));


    LoadCaregiverProfile$ = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadCaregiverProfile),
        mergeMap((action: LoadCaregiverProfile) => this.peopleService.getCaregiverProfile(action.payload as string).pipe(
            map((caregiver: CaregiverProfile) => (new LoadCaregiverProfileSuccess(caregiver)))).pipe(
                catchError(err => of(new LoadCaregiverProfileFail(err))))
        )));


    LoadProgramCoordinator$ = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadProgramCoordinator),
        mergeMap((action: LoadProgramCoordinator) => this.peopleService.getProgramCoordinator(action.payload as string).pipe(
            map((programCoordinator: ProgramCoordinatorDto) => (new LoadProgramCoordinatorSuccess(programCoordinator)))).pipe(
                catchError(err => of(new LoadProgramCoordinatorFail(err))))
        )));


    LoadProgramCoordinatorProfile$ = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadProgramCoordinatorProfile),
        mergeMap((action: LoadProgramCoordinatorProfile) => this.peopleService.getProgramCoordinatorProfile(action.payload as string).pipe(
            map((programCoordinator: ProgramCoordinatorProfile) => (new LoadProgramCoordinatorProfileSuccess(programCoordinator)))).pipe(
                catchError(err => of(new LoadProgramCoordinatorProfileFail(err))))
        )));


    EmployerOfRecordParticipantDetail = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadEmployerOfRecordParticipant),
        mergeMap((action: LoadEmployerOfRecordParticipant) => this.peopleService.getEmployerOfRecordParticipant(action.payload).pipe(
            map((EmployerOfRecordParticipantDto: Array<Relationships>) =>
                (new LoadEmployerOfRecordParticipantSuccess(EmployerOfRecordParticipantDto, action.payload)))).pipe(
                    catchError(err => of(new LoadEmployerOfRecordPersonFail(err))))
        )));


    EmployerOfRecordCaregiverDetail = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadEmployerOfRecordCaregiver),
        mergeMap((action: LoadEmployerOfRecordCaregiver) => this.peopleService.getEmployerOfRecordCaregiver(action.payload).pipe(
            map((EmployerOfRecordCaregiverDto: Array<Relationships>) =>
                (new LoadEmployerOfRecordCaregiverSuccess(EmployerOfRecordCaregiverDto, action.payload)))).pipe(
                    catchError(err => of(new LoadEmployerOfRecordPersonFail(err))))
        )));



    // SF Profile

    SFProfileDetail$ = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadPersonsSFProfile),
        mergeMap((action: GetSFProfile) => this.peopleService.getServiceFacilitatorProfile(action.payload).pipe(
            map((SFProfile: ServiceFacilitatorProfile) => (new LoadSFProfileSuccess(SFProfile)))).pipe(
                catchError(err => of(new LoadSFPersonFail(err))))
        )));


    SFAgencies = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadAgencies),
        mergeMap((action: GetSFAgencies) => this.peopleService.getServiceFacilitatorAgencies(action.peopleId).pipe(
            map((SFAgencies: Array<AgencyPersonMapping>) =>
                (new LoadSFAgencySuccess(SFAgencies, action.peopleId)))).pipe(
                    catchError(err => of(new LoadSFPersonFail(err))))
        )));


    CaregiverParticipantRelation$ = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadCaregiverParticipantRelation),
        // eslint-disable-next-line max-len
        mergeMap((action: LoadCaregiverParticipantRelation) => this.u2CustEmpService.getAllCustEmpRelations(action.payload as CustEmpRelFilterRequest).pipe(
            map((cgvParticpantRelation: CustEmpRelResponseDtoGridResponseBase) =>
                (new LoadCaregiverParticipantRelationSuccess(cgvParticpantRelation))
            )).pipe(catchError(err => of(new LoadCaregiverParticipantRelationFail(err))))
        )));


    CaregiverEmployerOfRecordRelation$ = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadCaregiverEmployerOfRecordRelation),
        // eslint-disable-next-line max-len
        mergeMap((action: LoadCaregiverEmployerOfRecordRelation) => this.peopleService.getCaregiverEmployerList(action.caregiverId as number).pipe(
            map((cgvEorRelation: CaregiverEmployerList[]) => (new LoadCaregiverEmployerOfRecordRelationSuccess(cgvEorRelation))
            )).pipe(catchError(err => of(new LoadCaregiverEmployerOfRecordRelationFail(err)))))
    ));


    SFCaseLoads = createEffect(() => this.action$.pipe(
        ofType(PersonActionTypes.LoadSFCaseLoads),
        mergeMap((action: GetSFCaseLoads) => this.peopleService.getServiceFacilitatorCaseLoad(action.peopleId).pipe(
            map((SFcaseLoad: Array<ServiceFacilitatorCaseLoad>) =>
                (new LoadSFCaseLoadsSuccess(SFcaseLoad, action.peopleId)))).pipe(
                    catchError(err => of(new LoadSFPersonFail(err))))
        )));
}
